import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/employee-daily-timescans', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const exportExcel = data => {
  return httpClient
    .post('/api/employee-daily-timescans/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const department = (Options = {}) => {
  return httpClient
    .get('/api/employee-daily-timescans/departments', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employee = (Options = {}) => {
  return httpClient
    .get('/api/employee-daily-timescans/employees', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const branch = (Options = {}) => {
  return httpClient
    .get('/api/employee-daily-timescans/branches', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const position = (Options = {}) => {
  return httpClient
    .get('/api/employee-daily-timescans/positions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employeeStatus = (Options = {}) => {
  return httpClient
    .get('/api/employee-daily-timescans/employee-status', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const latestCheckIn = staffId => {
  return httpClient
    .get(`/api/employee-daily-timescans/${staffId}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const store = data => {
  return httpClient
    .post('/api/employee-daily-timescans', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const employeeAttendanceGenerate = (Options = {}) => {
  return httpClient
    .get('/api/employee-daily-timescans/generates', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}


export default {
  get,
  exportExcel,
  department,
  branch,
  employee,
  position,
  employeeStatus,
  latestCheckIn,
  store,
  employeeAttendanceGenerate
}
